import axios from 'axios';

import prepareFormData from 'Modules/prepareFormData';
import { fetcher } from 'src/utils/fetcher';

import {
    TwoFactorEventDataResponseKey,
    type PostTwoFactorEventPayload,
    type PostTwoFactorEventResult,
} from 'src/components/AccountLogin/CombinedLoginCards/ApplicantLoginCard/hooks/useTwoFactor/types';

const TWO_FACTOR_EVENT_URL = '/account/login/two_factor_event';

export const postTwoFactorEvent = async (payload: PostTwoFactorEventPayload): Promise<PostTwoFactorEventResult> => {
    try {
        const formData = prepareFormData(payload) as unknown as PostTwoFactorEventPayload;
        await fetcher.post(TWO_FACTOR_EVENT_URL, formData);

        return { success: true, data: void 0 };
    } catch (error) {
        if (axios.isAxiosError(error)) {
            throw error;
        }

        return { success: false, error: TwoFactorEventDataResponseKey.Unknown };
    }
};
